<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer006">
<p class="Pull-Qutoes"><span class="com-rorohiko-pagestaker-style">vii</span>Dedicated to all my wonderful readers.</p>
<p class="ded"> You make the magic happen.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ded.vue?6617bb3c